import { functionLinks } from "../data/navLinks";

const LINKED_ENTITY_PATHS = {
  "/operation/orderService": "order",
  "/consultant/orderService": "order",
  "/management/orderService": "order",
  "/operation/orderInvestmentTransaction": "order",
  "/consultant/orderInvestmentTransaction": "order",
  "/management/orderInvestmentTransaction": "order",
};

export function getDefaultLinkedEntityForPath(linkPath) {
  return LINKED_ENTITY_PATHS[linkPath] ?? null;
}

export function resolveLinkedPageAccess({
  linkPath,
  accessRight,
  userRole,
  accessLinkEntity,
  getAccessRight,
}) {
  if (!accessLinkEntity || accessRight === 15) return accessRight;

  const entityLink = userRole?.entityLinks?.find(
    (l) => l.entity === accessLinkEntity,
  );
  let linkPathFromEntity = entityLink?.link;
  if (!linkPathFromEntity && accessLinkEntity === "order") {
    if (linkPath.includes("/consultant/")) {
      linkPathFromEntity = "/consultant/order";
    } else if (linkPath.includes("/management/")) {
      linkPathFromEntity = "/account/order";
    } else {
      linkPathFromEntity = "/operation/order";
    }
  }
  if (!linkPathFromEntity) return accessRight;

  const nav = functionLinks.find((f) => f.link === linkPathFromEntity);
  if (!nav?.linkId) return accessRight;
  return getAccessRight(nav.linkId) || accessRight;
}
